import { FC, CSSProperties } from "react";

interface Props {
  headers: {
    label: string;
    onClick?: () => void;
  }[];
}

const getEnvironmentListHeaderStyles = (
  onClick?: () => void
): CSSProperties => ({
  textAlign: "left",
  padding: "10px 15px",
  cursor: onClick ? "pointer" : "auto",
});

export const EnvironmentsListHeader: FC<Props> = ({ headers }) => {
  return (
    <thead>
      <tr>
        {headers.map((header, index) => (
          <th
            key={`${header} ${index}`}
            style={getEnvironmentListHeaderStyles(header?.onClick)}
            onClick={header?.onClick}
          >
            {header?.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};
